import { Fragment, type PropsWithChildren } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import {
  AccountContextProvider,
  AccountsContextProvider,
} from '@internal/backstage-plugin-catalog-devops';
import { ProjectsContextProvider } from '@internal/backstage-plugin-devops-admin';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';

// Account entity pages (any tab) get a single account context instance at the
// app root: the entity header's scan/settings actions and every tab content
// share one scan state. The wrapper renders inside the app router.
const ENTITY_ROUTE = '/catalog/:namespace/:kind/:name/*';

const AccountEntityRouteProvider = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const match = matchPath(ENTITY_ROUTE, pathname);
  const kind = match?.params.kind?.toLowerCase();
  const accountName = match?.params.name;
  if (kind !== 'account' || !accountName) {
    return <Fragment>{children}</Fragment>;
  }
  return (
    // key: navigating account A -> account B must not carry over A's scan
    // state; the remount gives every account a fresh provider instance.
    <AccountContextProvider key={accountName} accountName={accountName}>
      {children}
    </AccountContextProvider>
  );
};

export const RootContextProviders = AppRootWrapperBlueprint.make({
  name: 'root-context-providers',
  params: {
    component: ({ children }: PropsWithChildren) => (
      <ProjectsContextProvider>
        <AccountsContextProvider>
          <AccountEntityRouteProvider>{children}</AccountEntityRouteProvider>
        </AccountsContextProvider>
      </ProjectsContextProvider>
    ),
  },
});
